export const BONUS_PAGES = {
    TABLE: "table",
}

// tooltip names
export const BACK = 'Back to Menu';


export const BONUS_FIELDS = [
    {},
    {id: 'name', label: 'Name', align: "left"},
    {id: 'bonusName', label: 'Bonus Name', align: "left"},
    {id: 'specify', label: 'Specify', align: "left"},
    {id: 'machine', label: 'Machine', align: "left"},
    {id: 'bonusAmount', label: 'Bonus Amount', align: "left"},
    {}
]

export const CUSTOMER_BONUS_FIELDS = [
    {id: 'files', label: 'Picture', align: "center"},
  {id: 'firstName', label: 'First Name', align: "center"},
    {id: 'lastName', label: 'Last Name', align: "center"},
    {id: 'tagId', label: 'Tag Id', align: "center"},
]